import Vue from "vue";
import VueRouter from "vue-router";
import HomeRoute from "../views/Home.vue";
import MoneyRoute from "../views/Money.vue";
import ActivityRoute from "../views/Activity.vue";
import FoodRoute from "../views/Food.vue";
import DashRoute from "../views/Dash.vue";
import EditRoute from "../views/Edit.vue";
import GridRoute from "../views/Grid.vue";
import store from "../store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeRoute
  },
  {
    path: "/money",
    name: "Money",
    component: MoneyRoute,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.isAuthenticated) {
        next();
      } else {
        next("/");
      }
    }
  },
  {
    path: "/activity",
    name: "Activity",
    component: ActivityRoute,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.isAuthenticated) {
        next();
      } else {
        next("/");
      }
    }
  },
  {
    path: "/edit",
    name: "Edit",
    component: EditRoute,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.isAuthenticated) {
        next();
      } else {
        next("/");
      }
    }
  },
  {
    path: "/dash",
    name: "Dash",
    component: DashRoute,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.isAuthenticated) {
        next();
      } else {
        next("/");
      }
    }
  },
  {
    path: "/food",
    name: "Food",
    component: FoodRoute,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.isAuthenticated) {
        next();
      } else {
        next("/");
      }
    }
  },
  {
    path: "/grid",
    name: "Grid",
    component: GridRoute,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.isAuthenticated) {
        next();
      } else {
        next("/");
      }
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
